import request from '@/utils/request'

export function onlineOffline(data) {
    return request({
        url: '/backend/community/onlineOffline',
        method: 'post',
        data: data
    })
}

export function getMomentList(data) {
    return request({
        url: '/backend/community/getMomentList',
        method: 'post',
        data: data
    })
}

export function addChoice(data) {
    return request({
        url: '/backend/community/addChoice',
        method: 'post',
        data: data
    })
}

export function deleteMoment(data) {
    return request({
        url: '/backend/community/deleteMoment',
        method: 'post',
        data: data
    })
}

export function getMomentInfo(data) {
    return request({
        url: '/backend/community/getMomentInfo',
        method: 'post',
        data: data
    })
}

export function getMomentReplies(data) {
    return request({
        url: '/backend/community/getMomentReplies',
        method: 'post',
        data: data
    })
}

export function onlineOfflineReply(data) {
    return request({
        url: '/backend/community/onlineOfflineReply',
        method: 'post',
        data: data
    })
}

export function deleteReplies(data) {
    return request({
        url: '/backend/community/deleteReplies',
        method: 'post',
        data: data
    })
}

export function topicList(data) {
    return request({
        url: '/backend/community/topicList',
        method: 'post',
        data: data
    })
}

export function updateTopic(data) {
    return request({
        url: '/backend/community/updateTopic',
        method: 'post',
        data: data
    })
}

export function createTopic(data) {
    return request({
        url: '/backend/community/createTopic',
        method: 'post',
        data: data
    })
}

export function deleteTopic(data) {
    return request({
        url: '/backend/community/deleteTopic',
        method: 'post',
        data: data
    })
}